// Module
var code = `<div class="card">
    <div class="card-header scene-content-header" ng-style="{'border-bottom-color': ctrl.scene.color}">
        <!-- Mobile Layout: Single row with flex -->
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <!-- Left side: Title and Back button -->
            <div class="d-flex align-items-center flex-grow-1 scene-content-header-toggle"
                ng-click="ctrl.isCollapsed = !ctrl.isCollapsed">
                <i class="fas fa-fw flex-shrink-0"
                    ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
                <span class="card-title h4 ms-2 text-truncate" ng-show="!ctrl.activeSceneCollection">Scene
                    content</span>
                <span class="card-title h4 ms-2 text-truncate" ng-show="ctrl.activeSceneCollection">{{
                    ctrl.activeSceneCollection.name }}</span>
                <button type="button" class="btn btn-sm btn-outline-primary ms-2 flex-shrink-0"
                    ng-click="ctrl.removeActiveSceneCollection(); \$event.stopPropagation();"
                    ng-show="ctrl.activeSceneCollection">
                    <i class="fas fa-arrow-left"></i> <span class="d-none d-sm-inline">Back</span>
                </button>
            </div>
            <!-- Right side: Action buttons and duration -->
            <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                    ng-click="ctrl.showCalendar = true; \$event.stopPropagation();" ng-hide="ctrl.activeSceneCollection"
                    title="Open Calendar View">
                    <i class="fas fa-calendar-alt"></i> Calendar </button>
                <!-- Action buttons (visible when activeSceneCollection) -->
                <div class="d-flex gap-1" ng-show="ctrl.activeSceneCollection">
                    <button type="button" class="btn btn-sm btn-discreet-danger"
                        ng-click="\$event.stopPropagation(); ctrl.deleteAllSceneCollectionItems()"
                        ng-disabled="ctrl.isDeleting || ctrl.activeSceneCollectionItems.length === 0"
                        title="Slet alle elementer i denne playliste">
                        <i class="fas fa-trash-alt"></i> <span class="d-none d-md-inline">Delete All</span>
                    </button>
                    <button type="button" class="btn btn-sm btn-primary"
                        ng-click="\$event.stopPropagation(); ctrl.copySceneCollection(ctrl.activeSceneCollection.id)"
                        ng-disabled="ctrl.isDeleting || ctrl.activeSceneCollectionItems.length === 0"
                        title="Kopiér alle elementer fra denne playliste">
                        <i class="fas fa-copy"></i> <span class="d-none d-md-inline">Copy</span>
                    </button>
                    <button type="button" class="btn btn-sm btn-success"
                        ng-click="\$event.stopPropagation(); ctrl.pasteSceneCollectionItems(ctrl.activeSceneCollection.id)"
                        ng-show="ctrl.copiedSceneCollectionId">
                        <i class="fas fa-paste"></i> <span class="d-none d-md-inline">Paste</span>
                    </button>
                </div>
                <!-- Duration (visible when activeSceneCollection) -->
                <div class="text-muted small d-none d-lg-block" ng-show="ctrl.activeSceneCollection"> {{
                    ctrl.activeSceneCollection.totalDuration | duration }} </div>
            </div>
        </div>
    </div>
    <div ng-show="!ctrl.isCollapsed">
        <empty-info ng-show="ctrl.sceneCollections.length === 0 && !ctrl.showNewCollectionForm"
            no="content"></empty-info>
        <empty-info ng-show="ctrl.activeSceneCollection && ctrl.activeSceneCollectionItems.length === 0"
            no="content"></empty-info>
        <ul class="scene-content scene-collection-list list-unstyled list-striped"
            ng-show="(ctrl.sceneCollections.length > 0 || ctrl.showNewCollectionForm) && !ctrl.activeSceneCollection">
            <li class="scene-content-item"
                ng-attr-draggable="{{ctrl.editingCollectionId === item.id ? 'false' : 'true'}}"
                ng-attr-data-collection-id="{{item.id}}" ng-attr-data-collection-position="{{\$index}}"
                ng-class="{'placeholder': ctrl.collectionPlaceholderIndex === \$index}"
                ng-repeat="item in ctrl.sceneCollections | orderBy:'priority' track by item.id">
                <div class="d-flex align-items-center w-100" ng-if="ctrl.editingCollectionId !== item.id">
                    <span class="drag-handle d-flex align-items-center" title="Drag to reorder">
                        <i class="fas fa-grip-vertical"></i>
                    </span>
                    <button class="btn btn-outline-primary me-2 collection-name-btn"
                        ng-click="ctrl.setActiveSceneCollection(item.id)">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <span class="d-flex align-items-center text-truncate truncate-wrapper">
                                <i ng-if="item.id === ctrl.playingSceneCollection"
                                    class="fas fa-play me-1 flex-shrink-0 playing-icon"></i>
                                <span class="text-truncate">{{ item.name }}</span>
                            </span>
                            <i class="fas fa-list ms-2 flex-shrink-0 collection-list-icon"></i>
                        </div>
                    </button>
                    <div class="d-flex align-items-center gap-1 flex-shrink-0 ms-auto">
                        <span class="text-muted small d-none d-md-inline"><i class="far fa-clock"
                                aria-hidden="true"></i> {{ item.totalDuration | duration }}</span>
                        <!-- Scheduled intervals icon - clickable on mobile, hover on desktop -->
                        <span ng-if="ctrl.getActiveIntervals(item).length > 0"
                            class="text-muted position-relative interval-trigger"
                            ng-click="ctrl.toggleIntervalTooltip(item)">
                            <i class="far fa-calendar-alt" aria-hidden="true"></i>
                            <!-- Tooltip popup -->
                            <div ng-if="item.showIntervals" class="interval-tooltip">
                                <strong>Planlagte intervaller:</strong><br />
                                <div ng-repeat="interval in ctrl.getActiveIntervals(item)"
                                    class="interval-tooltip-item"> • {{ interval.readable_begin }} til {{
                                    interval.readable_end }}, prioritet {{ interval.priority }} </div>
                                <!-- Arrow pointing down -->
                                <div class="interval-tooltip-arrow">
                                </div>
                            </div>
                        </span>
                        <button class="btn btn-sm btn-outline-primary" type="button" ng-click="ctrl.playNow(item.id)"
                            ng-disabled="ctrl.isDeleting" title="Play Now"><i class="fas fa-play"></i></button>
                        <button class="btn btn-sm btn-outline-primary" type="button"
                            ng-click="ctrl.editCollectionName(item)" ng-disabled="ctrl.isDeleting" title="Edit"><i
                                class="fas fa-cog"></i></button>
                        <button class="btn btn-sm btn-discreet-danger" type="button"
                            ng-click="ctrl.deleteSceneCollection(item.id)" ng-disabled="ctrl.isDeleting" title="Delete">
                            <i class="fas fa-fw"
                                ng-class="{'fa-spinner fa-spin': ctrl.isDeleting, 'fa-trash': !ctrl.isDeleting}"></i>
                        </button>
                    </div>
                </div>
                <div class="scene-content-edit-row mt-2" ng-if="ctrl.editingCollectionId === item.id">
                    <form class="d-flex align-items-center" ng-submit="ctrl.saveCollectionName(item)">
                        <input type="text" class="form-control me-2" placeholder="Enter playlist name"
                            ng-model="ctrl.editedCollectionName" autofocus required>
                        <button class="btn btn-primary me-2" type="submit"
                            ng-style="{'background-color': ctrl.scene.color}">
                            Save
                        </button>
                        <button class="btn btn-outline-primary" type="button"
                            ng-click="ctrl.cancelEditCollectionName()">
                            Cancel
                        </button>
                    </form>
                </div>
            </li>
            <li class="scene-content-item" ng-show="ctrl.showNewCollectionForm" draggable="false">
                <div class="d-flex align-items-center w-100">
                    <span class="drag-handle d-flex align-items-center">
                        <i class="fas fa-grip-vertical"></i>
                    </span>
                    <form class="flex-grow-1 me-2" ng-submit="ctrl.saveNewSceneCollection()">
                        <div class="input-group">
                            <input type="text" class="form-control" placeholder="Enter playlist name"
                                ng-model="ctrl.newCollectionName" autofocus required>
                            <button class="btn btn-primary me-2" type="submit"
                                ng-style="{'background-color': ctrl.scene.color}">
                                Save
                            </button>
                            <button class="btn btn-outline-primary" type="button"
                                ng-click="ctrl.cancelNewSceneCollection()">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </li>
        </ul>
        <div class="scene-content-scrollable" ng-show="ctrl.activeSceneCollection">
            <ul class="scene-content list-unstyled list-striped">
                <li class="scene-content-item d-flex align-items-center" ng-attr-draggable="{{!durationForm.\$visible}}"
                    ng-attr-data-index="{{sceneCollectionItem.id}}" ng-attr-data-position="{{\$index}}"
                    ng-class="{'placeholder': ctrl.placeholderIndex === \$index}" ng-repeat="sceneCollectionItem in
                    ctrl.activeSceneCollectionItems | orderBy:'order' track by sceneCollectionItem.id">
                    <div class="flex-shrink-0 item-index-col">
                        <strong>{{\$index + 1}}</strong>
                        <i ng-if="sceneCollectionItem.mediaType === 'file'" class="fas fa-file ms-1"></i>
                        <i ng-if="sceneCollectionItem.mediaType === 'serviceAnnouncement'"
                            class="fas fa-bullhorn ms-1"></i>
                        <i ng-if="sceneCollectionItem.mediaType === 'social'" class="fas fa-users ms-1"></i>
                    </div>
                    <!-- Display media labels as colored dots vertically, overflow to new column after 2 -->
                    <div class="flex-shrink-0 d-flex align-items-center justify-content-start item-labels-col">
                        <div ng-if="sceneCollectionItem.media.labels.length > 0" class="d-flex item-labels-container">
                            <!-- First column (up to 2 dots vertically) -->
                            <div class="item-labels-column">
                                <div ng-repeat="label in sceneCollectionItem.media.labels | limitTo:2 track by label.id"
                                    class="label-dot-row">
                                    <span ng-style="{'background-color': label.color || '#007bff'}" class="label-dot"
                                        title="{{label.name}}">
                                    </span>
                                </div>
                            </div>
                            <!-- Second column (dots 3+, if any) -->
                            <div ng-if="sceneCollectionItem.media.labels.length > 2">
                                <div ng-repeat="label in sceneCollectionItem.media.labels.slice(2) track by label.id"
                                    class="label-dot-row">
                                    <span ng-style="{'background-color': label.color || '#007bff'}" class="label-dot"
                                        title="{{label.name}}">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-1 me-3 item-name-col">
                        <div class="text-truncate" title="{{sceneCollectionItem.media.name}}">
                            {{sceneCollectionItem.media.name}} </div>
                    </div>
                    <div class="flex-shrink-0">
                        <form ng-show="durationForm.\$visible" class="d-inline-flex align-items-center" editable-form
                            name="durationForm">
                            <span e-class="form-control form-control-sm" e-style="max-width: 60px;"
                                editable-text="sceneCollectionItem.duration / 1000" e-form="durationForm"
                                e-name="duration" e-required
                                onbeforesave="ctrl.validateAndSetDuration(sceneCollectionItem.id, \$data)"></span>
                            <button class="btn btn-sm btn-outline-primary ms-1" type="submit"
                                ng-disabled="durationForm.\$waiting"><i class="fas fa-check"></i></button>
                            <button class="btn btn-sm btn-outline-primary ms-1" type="button"
                                ng-disabled="durationForm.\$waiting" ng-click="durationForm.\$cancel()"><i
                                    class="fas fa-times"></i></button>
                        </form>
                        <button ng-show="!durationForm.\$visible" class="btn btn-sm btn-outline-primary" type="button"
                            ng-disabled="!ctrl.durationIsEditable(sceneCollectionItem)" ng-click="durationForm.\$show()">
                            {{sceneCollectionItem.duration | duration}}
                            <!--TODO: Read correct duration of FileMedia videos-->
                            <span ng-if="sceneCollectionItem.mediaType === 'social'"
                                class="text-muted d-none d-md-inline">({{sceneCollectionItem.duration / 10000 |
                                number:0}} items)</span>
                            <!--TODO: Fix hardcoded duration-->
                            <i ng-if="ctrl.durationIsEditable(sceneCollectionItem)" class="fas fa-pencil"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-primary d-none d-md-inline-block" type="button"
                            ng-show="\$index > 0"
                            ng-click="ctrl.orderUp(ctrl.activeSceneCollection.id, sceneCollectionItem.id)"
                            ng-disabled="ctrl.isDeleting">
                            <i class="fas fa-arrow-up"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-primary d-none d-md-inline-block" type="button"
                            ng-show="\$index < ctrl.activeSceneCollectionItems.length - 1"
                            ng-click="ctrl.orderDown(ctrl.activeSceneCollection.id, sceneCollectionItem.id)"
                            ng-disabled="ctrl.isDeleting">
                            <i class="fas fa-arrow-down"></i>
                        </button>
                        <button class="btn btn-sm btn-discreet-danger" type="button"
                            ng-click="ctrl.deleteSceneCollectionItem(sceneCollectionItem.id)"
                            ng-disabled="ctrl.isDeleting">
                            <i class="fas fa-fw"
                                ng-class="{'fa-spinner fa-spin': ctrl.isDeleting, 'fa-trash': !ctrl.isDeleting}"></i>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
        <div class="card-header">
            <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button type="button" class="btn btn-outline-secondary btn-sm" style="gap: 5px"
                    ng-if="ctrl.showCreateButton" ng-click="\$event.stopPropagation(); ctrl.createNewSceneCollection();"
                    ng-hide="ctrl.activeSceneCollection" style="margin: -5px;" aria-label="Add new playlist">
                    <i class="fas fa-plus-circle fa-1x"></i> Create new playlist </button>
            </div>
        </div>
        <!-- New Self-Contained Calendar Component -->
        <schedule-calendar scene-id="ctrl.scene" is-open="ctrl.showCalendar"
            on-close="ctrl.closeCalendar()"></schedule-calendar>`;
// Exports
export default code;